import qs from 'qs'

import {camelCaseObjectKeys, snakeCaseObjectKeys} from './helpers'
import {get, monolithGet, monolithPost} from './fetch'
import services from '../config/services'

const {MYTIME_COMPANY_ID, MYTIME_PUBLIC_BOOKING_API} = services

// Services/Variations
//

export const getMyTimeServices = (showroomId) =>
  get(
    `${MYTIME_PUBLIC_BOOKING_API}/companies/${MYTIME_COMPANY_ID}/variations/${qs.stringify(
      {
        location_id: showroomId,
      },
      {addQueryPrefix: true},
    )}`,
  ).then(camelCaseObjectKeys)

// Open Dates
//

export const getMyTimeOpenDates = (showroomId, variationId) =>
  get(
    `${MYTIME_PUBLIC_BOOKING_API}/open_dates/${qs.stringify(
      {
        location_id: showroomId,
        is_existing_customer: 'false',
        variation_ids: variationId,
      },
      {addQueryPrefix: true},
    )}`,
  ).then(camelCaseObjectKeys)

// Open Times
//

export const getMyTimeOpenTimes = (locationId, variationId, date) =>
  get(
    `${MYTIME_PUBLIC_BOOKING_API}/open_times/${qs.stringify(
      {
        location_id: locationId,
        is_existing_customer: 'false',
        variation_ids: variationId,
        date,
      },
      {addQueryPrefix: true},
    )}`,
  ).then(camelCaseObjectKeys)

// Create Appointment
// ----------------------------------------------------------------------------

export const createAppointment = (payload) =>
  monolithPost('/showroom-appointments/book', snakeCaseObjectKeys(payload)).then(
    camelCaseObjectKeys,
  )

// Get Appointment
// ----------------------------------------------------------------------------

export const getAppointment = (apptId, obfuscatedId) =>
  monolithGet(`/showroom-appointments/public/${apptId}?obfuscated_id=${obfuscatedId}`).then(
    camelCaseObjectKeys,
  )

// Cancel Appointment
// ----------------------------------------------------------------------------

export const cancelAppointment = (apptId, obfuscatedId) =>
  monolithPost(`/showroom-appointments/${apptId}/cancel`, {obfuscated_id: obfuscatedId}).then(
    camelCaseObjectKeys,
  )
